import React, { useEffect, useState } from "react";
import { CustomModal } from "../../../components/Modal/CustomModal";
import useUpdatePaymentMethod from "../../../react-query-hooks/useUpdatePaymentMethod";
import { Toast_Func } from "../../../helpers/toast.helper";
import StoredPaymentsListing from "./StoredPaymentsListing";
import { useQueryClient } from "react-query";
import StripePaymentElement from "../../../containers/order/PaymentMethod/StripePaymentElement";
import { useLocation } from "react-router-dom";
import { PULSE_VIEW_ID, trackPulseView } from "../../../analytics/pulseViewIds";
import { trackAddPaymentMethodClick } from "../../../analytics/pulseProfilePaymentClick";

interface StoredPaymentsProps {data: any, paymentRecords: any}

const StoredPayments: React.FunctionComponent<StoredPaymentsProps> = ({data: userProfileData, paymentRecords}) => {

  const { mutateAsync } = useUpdatePaymentMethod();
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [editRecordId, setEditRecordId] = useState(null);
  let queryClient = useQueryClient();
  const [defaultPayment, setDefaultPayment] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (!openPaymentModal) return;
    trackPulseView(PULSE_VIEW_ID.ADD_PAYMENT_METHOD_MODAL, {
      page_path: location.pathname,
    });
  }, [openPaymentModal, location.pathname]);

  const handleEdit = (id) => {
    setEditRecordId(id);
    setOpenPaymentModal(true);
  };
  const openAddPaymentMethodModal = () => {
    trackAddPaymentMethodClick(PULSE_VIEW_ID.PROFILE_PAYMENTS, location.pathname);
    setOpenPaymentModal(true);
  };
  const closeModal = () => {
    setOpenPaymentModal(false);
  };
  const [closeConfirmationModal, setCloseConfirmationModal] = useState(false);
useEffect(()=>{
  if(!defaultPayment){
    setDefaultPayment(paymentRecords.find(rec=>rec.is_default==true))
  }
},[paymentRecords])
  useEffect(() => {
    !openPaymentModal && editRecordId && setEditRecordId(null);
  }, [openPaymentModal]);
  const handleChangeDefault = async (id) => {
    const changedRecord = paymentRecords.find((rec) => rec.id == id);
    setDefaultPayment(changedRecord);
    return mutateAsync(
      {
        newPaymentMethod: {...changedRecord,is_default:true, customer_id: userProfileData.id },
        recordID: id,
      },
      {
        onSuccess: async(data) => {
          setDefaultPayment({...changedRecord,is_default:true})
          queryClient.invalidateQueries(["paymentMethod"]);
          queryClient.invalidateQueries(["profile"]);
          setCloseConfirmationModal(true)
          Toast_Func({ status: true, message: "Default updated successfully" });
        },
        onError: (error) => {
          Toast_Func({ status: false, message: error });
          setDefaultPayment(paymentRecords.find(rec=>rec.is_default==true))
        },
      }
    );
  };
  return (
    <>
      <StoredPaymentsListing
        closeConfirmationModal={closeConfirmationModal}
        paymentRecords={paymentRecords}
        defaultPayment={defaultPayment}
        handleChangeDefault={handleChangeDefault}
        handleEdit={handleEdit}
        setOpenPaymentModal={openAddPaymentMethodModal}
      />
      <CustomModal
        showModal={openPaymentModal}
        closeModal={() => setOpenPaymentModal(false)}
        title={`Payment`}
      >
          <StripePaymentElement isCheckout={false} closeProfileModal={closeModal}/>
      </CustomModal>
    </>
  );
};

export default StoredPayments;
